import axios from 'axios';
import { default as config } from '../../constants/constants';

export function updateIsFirstLogin(isFirstLogin) {
  return {
    type: 'UPDATE_IS_FIRST_LOGIN',
    payload: isFirstLogin
  };
}

export function signOutUser() {
  localStorage.clear();
  sessionStorage.clear();
  return { type: 'SIGN_OUT' };
}

export function getUser(token, callback) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/user`
  };

  const result = axios(options);

  result.then(() => {
    if (callback) {
      callback();
    }
  });

  return {
    type: 'FETCH_PODCAST_USER',
    payload: result
  };
}

export function getBraintreeClientToken(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/client_token`
  };

  return {
    type: 'FETCH_BRAINTREE_TOKEN',
    payload: axios(options)
  };
}

export function subscribe(
  token,
  nonce,
  firstname,
  lastname,
  email,
  phone,
  plan
) {
  const data = {
    nonce,
    firstname,
    lastname,
    email,
    phone,
    plan
  };

  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/subscription`,
    params: data
  };

  return axios(options);
}

export function cancelSubscription(token, success, error) {
  const options = {
    method: 'DELETE',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/subscription`
  };
  const request = axios(options);
  request.then(() => success()).catch((e) => error(e));
  return {
    type: 'CANCEL_SUBSCRIPTION',
    payload: request
  };
}

export function editSubscription(
  token,
  nonce,
  firstname,
  lastname,
  phone,
  success,
  error
) {
  const data = {
    nonce,
    firstname,
    lastname,
    phone
  };

  const options = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/subscription`,
    params: data
  };
  const request = axios(options);
  request.then(() => success()).catch((e) => error(e));
  return {
    type: 'EDIT_SUBSCRIPTION',
    payload: request
  };
}

export function activatePaypalUser(subscriptionId) {
  return {
    type: 'ACTIVATE_PAYPAL_USER',
    payload: subscriptionId
  };
}

export function fetchSubscriptions(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/subscription/`
  };
  return {
    type: 'FETCH_SUBSCRIPTIONS',
    payload: axios(options)
  };
}

export function fetchSubscription(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/subscription`
  };
  return {
    type: 'FETCH_SUBSCRIPTION',
    payload: axios(options)
  };
}

export function fetchMysubscriptions(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/mysubscriptions`
  };
  return {
    type: 'FETCH_MY_SUBSCRIPTIONS',
    payload: axios(options)
  };
}

export function setFirebaseInfo(values) {
  return {
    type: 'SET_FIREBASE_INFO',
    payload: values
  };
}

export function userStatusClaim(token, coupon) {
  const data = {
    coupon
  };

  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/signup`,
    params: data
  };
  return {
    type: 'USER_STATUS_CLAIM',
    payload: axios(options)
  };
}

export function startFreeTrial(token, coupon) {
  const data = {
    coupon
  };

  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/freetrial2`,
    params: data
  };
  return {
    type: 'START_FREE_TRIAL',
    payload: axios(options)
  };
}

export function isAdmin(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/claims`
  };
  return {
    type: 'IS_ADMIN',
    payload: axios(options)
  };
}

export function getPlans(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/paypal/plans`
  };
  return {
    type: 'FETCH_PLANS',
    payload: axios(options)
  };
}

export function checkInvitationLink(code) {
  const options = {
    method: 'GET',
    url: `${config.serverURL}/invitations?code=${code}`
  };
  return {
    type: 'CHECK_INVITATION_LINK',
    payload: axios(options)
  };
}

export function showOnBoardingMsg(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/invitations/msg`
  };
  return {
    type: 'SHOW_MSG',
    payload: axios(options)
  };
}

export function fetchCategoryTypesByUser(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/categoryTypes/categoryTypesByUser`
  };
  return {
    type: 'CATEGORY_TYPES_BY_USER',
    payload: axios(options)
  };
}

export function updateUserData(values) {
  return {
    type: 'UPDATE_USER_DATA',
    payload: values
  };
}
